import EventBus from "./event-bus";

const axios = require('axios');

import {errorHandler} from "./common";


export function getMainAgent() {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    let url = process.env.ROOT_API + 'admin/agent/main';

    axios.get(url, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("get Merchant List");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getAgents(type = null) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    let url = process.env.ROOT_API + 'admin/agents';
    if(type != null) {
      url += '?type=' + type;
    }
    axios.get(url, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("get Merchant List");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getAgent(id) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'admin/agent?id=' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("get Agent");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getMerchantAgent(id) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'merchant/agent?id=' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("get Agent");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function getAgencyAgent(id) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'agency/agent?id=' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("get Agent");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function deleteAgent(id) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.delete(process.env.ROOT_API + 'admin/agent?id=' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Delete Agent");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function updateAgent(agent) {
  return new Promise(function (resolve, reject) {
    axios.post(process.env.ROOT_API + 'admin/agent', JSON.stringify(agent), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("Agent Item update");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error);
      });
  })
}
export function createNewAgent() {
  let item = {
    id:0,
    title:'',
    description:'',
    address1:'',
    address2:'',
    address3:'',
    postCode:'',
    email:'',
    telephone:'',
    fax:'',
    courier:'post office',
    numberMin:0,
    numberMax:0,
    deleted:false,
    edit:true,

  }
  return item;
}
export function searchOrganisations(type, query) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/organisations/' + type + '/search?'+ query,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/agents.js